import React from 'react';
import { GovIcon } from '@gov-design-system-ce/react';
import { GovFormWeb } from '@gov-design-system-ce/react-form';
import { MarkdownRender, RezaListSkeleton } from '@gov-nx/component/web';
import {
	useRezaListContext,
	useRezaLocale,
	zastupujiciOsobaNazev,
} from '@gov-nx/module/page';
import {
	Button,
	ContentLayout,
	ErrorStatusBanner,
	FilterParameterList,
	FormTabs,
	HeaderSearchBar,
	InfoBanner,
	KeyValues,
	LayoutGap,
	Tile,
	Tiles,
} from '@gov-nx/ui/web';
import { toDateReadable } from '@gov-nx/utils/common';
import { pageRouteResolver } from '@gov-nx/web';
import { RezaNotAllDisplayedMessage } from '../../RezaNotAllDisplayedMessage';
import { FilterModal } from '../../seznam/FilterModal';

export const RezaArchiveList = () => {
	const { t } = useRezaLocale();
	const {
		code,
		isLoading,
		isError,
		data,
		formDefinition,
		onSubmit,
		onFilterReset,
		filterParams,
		isFilterModalOpen,
	} = useRezaListContext();

	return (
		<LayoutGap>
			<ContentLayout>
				<GovFormWeb
					formDefinition={formDefinition}
					onSubmit={onSubmit}>
					<HeaderSearchBar
						fields={{
							search: formDefinition.fields.text,
							button: formDefinition.fields.button,
						}}
						filterParams={
							<FilterParameterList
								items={filterParams}
								onReset={onFilterReset}
							/>
						}>
						<Button
							onClick={isFilterModalOpen.setTrue}
							color="primary"
							type="outlined"
							className="ml-auto"
							aria-label={t('akce.zobrazit-filtr.wcag')}>
							<GovIcon
								name="funnel"
								type="templates"
								slot="icon-start"
							/>
						</Button>
					</HeaderSearchBar>

					<RezaNotAllDisplayedMessage />

					<FormTabs {...formDefinition.fields.role} />

					<FilterModal />
				</GovFormWeb>

				{isLoading ? (
					<RezaListSkeleton />
				) : isError ? (
					<ErrorStatusBanner code={code} />
				) : data.length === 0 ? (
					<InfoBanner
						headline={t('stav.chyba.zadny-zaznam')}
						text={t('stav.chyba.v-reza-nejsou-data')}
					/>
				) : (
					<Tiles>
						{data.map((row) => (
							<Tile
								key={[
									row.kod,
									row.role,
									row.typ,
									row.stav,
									row.platnostOd,
									row.zastupujiciOsobaTyp,
									row.kodSablony,
								].join('-')}
								name={row.nazevSablony ?? '-'}
								to={pageRouteResolver('reza.detail', { id: row.kod })}
								icon={{ name: 'chevron-right', type: 'components' }}>
								<div className="text-(--text-secondary)">
									<KeyValues
										options={[
											{
												label: t('seznam.item.platnost-od.label'),
												value: row.platnostOd
													? toDateReadable(row.platnostOd)
													: '-',
											},
											{
												label: t('seznam.item.platnost-do.label'),
												value: row.platnostDo
													? toDateReadable(row.platnostDo)
													: t('seznam.item.platnost-do.empty'),
											},
											{
												label:
													row.role === 'zmocnenec'
														? t('seznam.item.zmocnenec')
														: t('seznam.item.zmocnitel'),
												value: zastupujiciOsobaNazev(row) ?? '-',
											},
											{
												label: t('seznam.item.identifikator'),
												value: row.kod,
											},
										]}
									/>
								</div>
							</Tile>
						))}
					</Tiles>
				)}
			</ContentLayout>

			<MarkdownRender>
				{t('seznam.footer', {
					link: pageRouteResolver('reza.templates'),
				})}
			</MarkdownRender>
		</LayoutGap>
	);
};
